<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">{{ $t('부가정보') }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideCustom"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <v-row
          class="mt-8"
          v-for="(rows, idx) in customs"
          :key="'customrow' + idx"
        >
          <v-col
            :cols="12 / rows.length"
            v-for="(item, i) in rows"
            class="mt-2 btn-post-wrap"
            :key="'costom' + i"
          >
            <i-text-field
              v-maxlength="'custom1'"
              v-model="item.value"
              :label="item.label"
              outlined
              dense
              hide-details="auto"
              @blur="save"
              :readonly="isReadonly"
              :rules="[rules.required(item.name)]"
            ></i-text-field>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    customs: [],
    alert: false,
  }),
  methods: {
    setting: function() {
      this.customs = [];
      var rows = [];

      // CHARCODE A -> 65;
      var size = this.template.typeCustom.charCodeAt(0) - 63;
      for (let i = 1; i < size; i++) {
        let preName = 'custom' + i;

        if (this.opts[preName]) {
          let obj = {
            label: this.template[preName] ? this.template[preName] : '',
            name: preName,
            value: this.desc(preName),
          };

          rows.push(obj);
          if (rows.length == 3) {
            this.customs.push(rows);
            rows = [];
          }
        }
        if (i == size - 1 && rows.length > 0) this.customs.push(rows);
      }
    },
    desc: function(preName) {
      let id = '';
      if (
        this.info &&
        this.info.custom &&
        this.info.custom.hasOwnProperty(preName)
      ) {
        id = this.info.custom[preName];
      }

      return id;
    },
    valid: function() {
      return this.$refs.form.validate();
    },
    save: function() {
      const id = { annoId: this.$route.params.annoId };
      const p = { id: id };

      for (var rows of this.customs) {
        for (var item of rows) {
          p[item.name] = item.value;
        }
      }

      this.$emit('save', p, 'custom');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('CUSTOM INFO SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.customTitle)}` +
            this.$t('가 저장 되었습니다.'),
        );
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
